import React from 'react';

export function CopyField({ id, label, value, onChange, multiline, hint }) {
  return (
    <div className="col-12">
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      {multiline ? (
        <textarea
          id={id}
          className="form-control"
          rows={typeof multiline === 'number' ? multiline : 3}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input id={id} className="form-control" value={value} onChange={(e) => onChange(e.target.value)} />
      )}
      {hint ? <div className="form-text">{hint}</div> : null}
    </div>
  );
}

export function CopyCard({ title, subtitle, children }) {
  return (
    <div className="card border shadow-sm mb-3">
      <div className="card-header py-2">
        <h2 className="h6 mb-0">{title}</h2>
        {subtitle ? <p className="small text-muted mb-0 mt-1">{subtitle}</p> : null}
      </div>
      <div className="card-body">
        <div className="row g-3">{children}</div>
      </div>
    </div>
  );
}

export function setPageCopySection(form, setField, section, patch) {
  const page = form.page_copy || {};
  setField('page_copy', {
    ...page,
    [section]: { ...(page[section] || {}), ...patch },
  });
}

export function setStoreCopy(form, setField, patch) {
  setField('store_copy', { ...(form.store_copy || {}), ...patch });
}
